import { render, staticRenderFns } from "./FreightTableRoutesFilters.vue?vue&type=template&id=52dfca24&scoped=true"
import script from "./FreightTableRoutesFilters.vue?vue&type=script&lang=js"
export * from "./FreightTableRoutesFilters.vue?vue&type=script&lang=js"
import style0 from "./FreightTableRoutesFilters.vue?vue&type=style&index=0&id=52dfca24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfca24",
  null
  
)

export default component.exports